export const SF852013 = {
  HISTORY_RESIDENCE_YEARS: 5,
  HISTORY_EDUCATION_YEARS: 5,
  HISTORY_EMPLOYMENT_YEARS: 5,
  HISTORY_EMPLOYMENT_RECORD_YEARS: 5,
  MILITARY_DISCIPLINARY_RECORD_YEARS: 5,
  FINANCIAL_RECORD_TAXES_YEARS: 5,
  FINANCIAL_RECORD_DELINQUENT_YEARS: 5,
  SUBSTANCE_ALCOHOL_TREATMENT_YEARS: '',
  SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS: '',
  SUBSTANCE_DRUG_USE_YEARS: 1,
  SUBSTANCE_DRUG_TREATMENT_YEARS: 1,
  LEGAL_POLICE_RECORD_YEARS: 5,
  LEGAL_INVESTIGATED_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DENIED_CLEARANCE_YEARS: 5,
  LEGAL_INVESTIGATED_DEBARRED_YEARS: 5,
  FORM_LABEL: 'SF-85',
  RELATIONSHIPS_PEOPLE_YEARS: 5,
};

export const SF85 = {
  HISTORY_RESIDENCE_YEARS: 5,
  HISTORY_EDUCATION_YEARS: 5,
  HISTORY_EMPLOYMENT_YEARS: 5,
  HISTORY_EMPLOYMENT_RECORD_YEARS: 5,
  MILITARY_DISCIPLINARY_RECORD_YEARS: 5,
  FINANCIAL_RECORD_TAXES_YEARS: 5,
  FINANCIAL_RECORD_DELINQUENT_YEARS: 5,
  SUBSTANCE_ALCOHOL_TREATMENT_YEARS: '',
  SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS: '',
  SUBSTANCE_DRUG_USE_YEARS: 1,
  SUBSTANCE_DRUG_TREATMENT_YEARS: 1,
  LEGAL_POLICE_RECORD_YEARS: 5,
  LEGAL_INVESTIGATED_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DENIED_CLEARANCE_YEARS: 5,
  LEGAL_INVESTIGATED_DEBARRED_YEARS: 5,
  FORM_LABEL: 'SF-85',
  RELATIONSHIPS_PEOPLE_YEARS: 7,
};

export const SF85P = {
  HISTORY_RESIDENCE_YEARS: 7,
  HISTORY_EDUCATION_YEARS: 7,
  HISTORY_EMPLOYMENT_YEARS: 7,
  HISTORY_EMPLOYMENT_RECORD_YEARS: 7,
  FINANCIAL_RECORD_GAMBLING_YEARS: 7,
  MILITARY_DISCIPLINARY_RECORD_YEARS: 7,
  FINANCIAL_RECORD_BANKRUPTCY: 7,
  FINANCIAL_RECORD_TAXES_YEARS: 7,
  FINANCIAL_RECORD_DELINQUENT_YEARS: 7,
  SUBSTANCE_DRUG_USE_YEARS: 7,
  SUBSTANCE_DRUG_TREATMENT_YEARS: 7,
  SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS: 7,
  SUBSTANCE_ALCOHOL_TREATMENT_YEARS: 7,
  LEGAL_POLICE_RECORD_YEARS: 7,
  LEGAL_COURT_YEARS: 7,
  LEGAL_INVESTIGATED_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DENIED_CLEARANCE_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DEBARRED_YEARS: 'EVER',
  FORM_LABEL: 'SF-85P',
  RELATIONSHIPS_PEOPLE_YEARS: 7,
};

export const SF85PS = {
  HISTORY_RESIDENCE_YEARS: 7,
  HISTORY_EDUCATION_YEARS: 7,
  HISTORY_EMPLOYMENT_YEARS: 7,
  HISTORY_EMPLOYMENT_RECORD_YEARS: 7,
  FINANCIAL_RECORD_BANKRUPTCY: 7,
  FINANCIAL_RECORD_GAMBLING_YEARS: 7,
  MILITARY_DISCIPLINARY_RECORD_YEARS: 7,
  FINANCIAL_RECORD_TAXES_YEARS: 7,
  FINANCIAL_RECORD_DELINQUENT_YEARS: 7,
  SUBSTANCE_DRUG_USE_YEARS: 7,
  SUBSTANCE_DRUG_TREATMENT_YEARS: 7,
  SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS: 7,
  SUBSTANCE_ALCOHOL_TREATMENT_YEARS: 7,
  LEGAL_POLICE_RECORD_YEARS: 7,
  LEGAL_COURT_YEARS: 7,
  LEGAL_INVESTIGATED_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DENIED_CLEARANCE_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DEBARRED_YEARS: 'EVER',
  FORM_LABEL: 'SF85P+85P-S',
  RELATIONSHIPS_PEOPLE_YEARS: 7,
};

export const SF86 = {
  HISTORY_RESIDENCE_YEARS: 10,
  HISTORY_EDUCATION_YEARS: 10,
  HISTORY_EMPLOYMENT_YEARS: 10,
  HISTORY_EMPLOYMENT_RECORD_YEARS: 7,
  HISTORY_FEDERAL_YEARS: 10,
  MILITARY_DISCIPLINARY_RECORD_YEARS: 7,
  FINANCIAL_RECORD_BANKRUPTCY: 7,
  FINANCIAL_RECORD_TAXES_YEARS: 7,
  FINANCIAL_RECORD_DELINQUENT_YEARS: 7,
  FINANCIAL_RECORD_GAMBLING_YEARS: 'EVER',
  SUBSTANCE_DRUG_USE_YEARS: 7,
  SUBSTANCE_DRUG_TREATMENT_YEARS: 'EVER',
  SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS: 'EVER',
  SUBSTANCE_ALCOHOL_TREATMENT_YEARS: 'EVER',
  LEGAL_POLICE_RECORD_YEARS: 7,
  LEGAL_COURT_YEARS: 10,
  LEGAL_INVESTIGATED_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DENIED_CLEARANCE_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DEBARRED_YEARS: 'EVER',
  FORM_LABEL: 'SF-86',
  RELATIONSHIPS_PEOPLE_YEARS: 7,
};

export const PVQ_A = {
  HISTORY_RESIDENCE_YEARS: 5,
  HISTORY_EDUCATION_YEARS: 5,
  HISTORY_EMPLOYMENT_YEARS: 5,
  HISTORY_EMPLOYMENT_RECORD_YEARS: 5,
  HISTORY_FEDERAL_YEARS: 10,
  MILITARY_DISCIPLINARY_RECORD_YEARS: 7,
  FINANCIAL_RECORD_BANKRUPTCY: 7,
  FINANCIAL_RECORD_TAXES_YEARS: 7,
  FINANCIAL_RECORD_DELINQUENT_YEARS: 7,
  FINANCIAL_RECORD_GAMBLING_YEARS: 'EVER',
  SUBSTANCE_DRUG_USE_YEARS: 5,
  SUBSTANCE_DRUG_TREATMENT_YEARS: 'EVER',
  SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS: 'EVER',
  SUBSTANCE_THC_USE_YEARS: 5,
  SUBSTANCE_ALCOHOL_TREATMENT_YEARS: '5',
  LEGAL_POLICE_RECORD_YEARS: 5,
  LEGAL_COURT_YEARS: 5,
  LEGAL_INVESTIGATED_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DENIED_CLEARANCE_YEARS: 'EVER',
  LEGAL_INVESTIGATED_DEBARRED_YEARS: 'EVER',
  LEGAL_TECHNOLOGY_UNAUTHORIZED_USE_YEARS: 5,
  FORM_LABEL: 'PVQ-A',
  RELATIONSHIPS_PEOPLE_YEARS: 5,
};

export const PVQ_A_B = {
  ...PVQ_A,
  FORM_LABEL: 'PVQ-A-B',
};
export const PVQ_A_B_C = {
  ...PVQ_A_B,
  FORM_LABEL: 'PVQ-A-B-C',
};
export const PVQ_A_B_D = {
  ...PVQ_A_B,
  FORM_LABEL: 'PVQ-A-B-D',
};

export const formConfig = {
  SF852013, SF85, SF85P, SF86, 'SF85P+85P-S': SF85PS, 'PVQ-A': PVQ_A, 'PVQ-A-B': PVQ_A_B, 'PVQ-A-B-C': PVQ_A_B_C, 'PVQ-A-B-D': PVQ_A_B_D,
};
